export const ChevronRight = ({ color = 'white' }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='9' height='12' viewBox='0 0 9 12' fill='none'>
    <path d='M1.0564 1L7 5.97635L1 11' stroke={color} strokeWidth='2' strokeLinecap='round' />
  </svg>
)
